var _g, _path, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarPtWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-27.183 1498.305 1.446-.7a1.308 1.308 0 0 1 .459-.08h8.612a1.323 1.323 0 0 1 .453.08l1.446.7",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    transform: "translate(48.599 -1496.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.742 1v3.186",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-14.657 1519.861a1.082 1.082 0 0 1 1.081 1.084 1.082 1.082 0 0 1 -1.083 1.081 1.082 1.082 0 0 1 -1.081-1.081 1.084 1.084 0 0 1 1.083-1.084z",
    fill: "#3a3a3a",
    transform: "translate(48.599 -1496.529)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-30.316 1506.475c0-.374.551-.648 1.208-.679 5.792-.269 10.478-.229 16.268 0 .659.026 1.207.306 1.207.679",
    transform: "translate(48.599 -1496.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-11.635 1515.652c0 .83-7.009 1.154-12.441.967",
    transform: "translate(48.599 -1496.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-30.316 1513.251v-8.613a3.9 3.9 0 0 1 3.844-3.937v.006h10.995a3.9 3.9 0 0 1 3.843 3.937v18.626a2.6 2.6 0 0 1 -2.236 2.159 67.938 67.938 0 0 1 -9.4.334",
    transform: "translate(48.599 -1496.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.715 32.024h13.435"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.529 1511.448a2.311 2.311 0 0 1 -2.305-2.316 2.311 2.311 0 0 1 2.316-2.3 2.31 2.31 0 0 1 2.305 2.316 2.308 2.308 0 0 1 -2.312 2.305z",
    transform: "translate(48.599 -1496.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-7.978 1518.981a4.761 4.761 0 0 1 4.76-4.76",
    transform: "translate(48.599 -1496.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.6 1521.36c2.508 0 4.538 3.2 4.538 7.156",
    transform: "translate(48.599 -1496.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.542 1518.981a4.76 4.76 0 0 1 -4.76-4.76",
    transform: "translate(48.599 -1496.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.381 17.691-4.76 14.278"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.167 28.206h-9.167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-46.6 1509.614h.208a7.22 7.22 0 0 1 4.5 1.576c1.206.963 2.677 2.16 3.562 2.963a7.17 7.17 0 0 0 3 1.628l7.92 2.081a1.765 1.765 0 0 1 1.317 1.708v3.446a1.721 1.721 0 0 1 -1.72 1.72h-2.061",
    transform: "translate(48.599 -1496.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.947,
    cy: 28.205,
    r: 3.78
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarPtWalk);
export default __webpack_public_path__ + "static/media/car-pt-walk.d11e8d69e03034d9e0bb8b98c9154aed.svg";
export { ForwardRef as ReactComponent };